import { useEffect } from 'react'
import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { GeneralSettingsForm } from '@/components/forms/GeneralSettingsForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function GeneralSettingsPage() {
  const colors = useThemeColors()

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">General Settings</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Configure general application settings, site information, and preferences
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <GeneralSettingsForm />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}


